import { Offer } from "@comparaonline/offers-models";
import { NEW_CAR_ATTRIBUTE_CODE } from "../../../models/product";
import { getProductAttributeByCode } from "./getProductAttributeByCode";

const DEFAULT_VALUE_ALL_COMPANIES = "48 horas";
const DEFAULT_VALUE_REALE_CL = "10 días hábiles";

const REALE_CL_COMPANY_CODE = "reale_cl";

type GetTimeToConsiderItNew = (companyCode: string, offer?: Offer) => string;

export const getTimeToConsiderItNew: GetTimeToConsiderItNew = (companyCode, offer) => {
  if (!offer || !companyCode) return DEFAULT_VALUE_ALL_COMPANIES;

  const newCar = getProductAttributeByCode(offer, NEW_CAR_ATTRIBUTE_CODE);

  if (newCar && newCar.value) return newCar.value;

  return companyCode === REALE_CL_COMPANY_CODE
    ? DEFAULT_VALUE_REALE_CL
    : DEFAULT_VALUE_ALL_COMPANIES;
};
